import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const documentOptions = {}

const initialState = {
  options: documentOptions,
  activeOption: '',
  activeTab: 'selectDocument',
  success: false,
}

const documentRequestSlice = createSlice({
  name: 'documentRequest',
  initialState,
  reducers: {
    toggleDocument: (state, action: PayloadAction<string>) => {
      state.options[action.payload].selected = !state.options[action.payload].selected
    },
    editMessage: (state, action: PayloadAction<{ document: string; cannedMessage: string }>) => {
      state.options[action.payload.document].cannedMessage = action.payload.cannedMessage
    },
    setActiveDocumentOption: (state, action: PayloadAction<string>) => {
      state.activeOption = action.payload
    },
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.activeTab = action.payload
    },
    setDocumentRequestStatus: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload
    },
    resetDocumentRequestState: () => initialState,
    addOptions: (state, action: PayloadAction<any>) => {
      state.options = { ...state.options, ...action.payload }
    },
  },
})

export const {
  toggleDocument,
  editMessage,
  setActiveDocumentOption,
  setActiveTab,
  setDocumentRequestStatus,
  resetDocumentRequestState,
  addOptions,
} = documentRequestSlice.actions

export const documentRequestReducer = documentRequestSlice.reducer
